import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center space-y-6 p-8">
        <h1 className="text-9xl font-bold text-blue-600">404</h1>
        <div className="space-y-2">
          <h2 className="text-2xl font-semibold text-gray-900">عذراً، الصفحة غير موجودة</h2>
          <p className="text-gray-500">الصفحة التي تبحث عنها غير موجودة أو تم نقلها</p>
        </div>
        <div className="flex justify-center gap-4">
          <Button onClick={() => navigate(-1)} variant="outline">
            العودة للخلف
          </Button>
          <Button onClick={() => navigate("/")}>
            العودة للرئيسية
          </Button>
        </div>
      </div>
    </div>
  );
}
